interface Props {
  name: string;
}

const FormLoader = ({ name }: Props) => {
  return (
    <div className="pt-8">
      <div className="relative mb-2 mt-1 inline-flex items-center space-x-1 overflow-hidden rounded-wt px-2 py-1 text-xs">
        <div className="absolute inset-0 bg-wt-primary text-wt-primary opacity-10" />
        <span className="z-10 font-medium text-wt-primary">{name}</span>
      </div>
      <div className="flex w-full animate-pulse flex-col space-y-6">
        <div className="h-12 w-full max-w-xs rounded bg-gray-200" />
        <div className="space-y-4">
          <div className="h-8 w-full rounded bg-gray-200" />
          <div className="h-8 w-full rounded bg-gray-200" />
          <div className="h-8 w-full rounded bg-gray-200" />
        </div>
      </div>
    </div>
  );
};

export default FormLoader;
